import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import type { ISODate } from '../../common/utils';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';

const putChangeVisualValidationTimeSeriesData = ({
  externalCode,
  ...data
}: {
  externalCode: string;
  dataObjectVersionIds: number[];
  valueDateFrom: ISODate;
  valueDateTo: ISODate;
  ruleCode: string;
  outliers: boolean;
  hp: boolean;
}) => {
  let url: string = ValidationDashboardUrl.TIME_SERIES_CHANGE_DATA;
  if (data.hp) {
    url = ValidationDashboardUrl.HODRICK_PRESCOTT_CHANGE_DATA;
  } else if (data.outliers) {
    url = ValidationDashboardUrl.OUTLIERS_CHANGE_DATA;
  }

  return apiClient
    .put<{
      externalCode: string;
    }>(expand(url, { externalCode }), data)
    .then((response) => response.data);
};

export const useChangeVisualValidationTimeSeriesDataMutation =
  createApiMutationHook(
    ['changeVisualValidationTimeSeriesData'],
    putChangeVisualValidationTimeSeriesData,
  );
